import { Customer_MarketingConsents } from 'data/endpoints';
import { useQuery } from 'data/hooks/useQuery';
import NoContentWrapper from 'features/shared/components/noContentWrapper/NoContentWrapper';
import { UserEnumDTO } from 'features/shared/enums/dynamic/UserEnumDTO';
import { getRouteParams } from 'features/shared/helpers/routeParams';
import CustomerState from 'infrastructure/store/customer/CustomerState';
import IAppState from 'infrastructure/store/IAppState';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MarketingConsentsDialog from 'features/consents/components/MarketingConsentsDialog';
import MarketingConsentReactionDTO from 'features/consents/dtos/MarketingConsentReactionDTO';
import { useInjection } from 'infrastructure/ioc/ioc.react';
import IRepository from 'data/IRepository';
import { IocTypes } from 'infrastructure/ioc/ioc.types';
import { trackPromise } from 'react-promise-tracker';
import { Dashboard_MarketingConsentsDialog } from 'features/shared/components/loaders/promiseLoadingAreas';
import { Dispatch } from 'redux';
import { MarketingConsentsAction, setClosedDialog } from 'infrastructure/store/marketingConsents/MarketingConsentsActions';

const MarketingConsentsSection = () => {
  // DI
  const consentRepository = useInjection<IRepository<MarketingConsentReactionDTO[]>>(IocTypes.Repository);

  // store
  const customer = useSelector<IAppState, CustomerState>((store) => store.customer).customer;
  const consentsDispatch = useDispatch<Dispatch<MarketingConsentsAction>>();

  // state
 const [consentDialgShow, setConsentDialogShow] = useState(true);

  // fetch data
  const { data, loadStatus } = useQuery<UserEnumDTO[]>(
    {
      url: Customer_MarketingConsents,
      routeParams: getRouteParams("customerId", customer.customerId!)
    },
    [],
    [customer.customerId]
  );

  // handlers
  const sendMarketingConsentsHandler = async (consents: MarketingConsentReactionDTO[]) => {    
    await trackPromise(
      consentRepository.post({
        url: Customer_MarketingConsents,
        routeParams: getRouteParams("customerId", customer.customerId!),
        data: consents,
      }),
      Dashboard_MarketingConsentsDialog
    );

    setConsentDialogShow(false);
  }

  const closeDialogHandler = () => { 
    consentsDispatch(setClosedDialog(true));
    setConsentDialogShow(false);
  }

  // render
  return (
    <NoContentWrapper
      data={data}
      loadStatus={loadStatus}
      noContentRender={() => <></>}
    >
      <MarketingConsentsDialog 
        show={consentDialgShow}
        consentTypes={data}
        onSubmit={sendMarketingConsentsHandler}
        onClose={closeDialogHandler}
      />
    </NoContentWrapper>
  )
}

export default MarketingConsentsSection;